var map = {
	"./ITT-logo.jpg": "6e3a",
	"./black-logo.png": "1a51",
	"./cimpress.png": "1012",
	"./eliza.png": "dee0",
	"./itt.png": "c3d5",
	"./transparent-logo.png": "4c3a",
	"./tyco.png": "7c4d",
	"./veracode.png": "eaac",
	"./verizon.png": "ac97",
	"./white-logo.png": "036c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09d7";